<template>
    <div>
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <BreadCrumbsComponent  :breadcrumbs="breadcrumbs" :class="`margin-breadcrumb ${scrollTop ? '' : 'mt-132'}`"/>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6">
            <div class="orange--text mt-md-16 mb-5 text-h5 text-sm-h4 font-title"><b><i>TRABAJE CON NOSOTROS</i></b></div>
            <span class='grayblack--text font-text'>Si desea ser parte de Grupo Innofarm. ¡Puede enviarnos su hoja de vida! <br />Rellene el siguiente formulario:</span>
            <div class='col-md-8 px-0'>
                <v-form ref="form_quote">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model=firstName
                                :rules=ruleRequire
                                outlined
                                dense
                                rounded
                            >
                                <template v-slot:label>
                                    <span class='gray--text font-title'> <i>Nombre *</i></span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model=lastName
                                :rules=ruleRequire
                                outlined
                                dense
                                rounded
                            >
                                <template v-slot:label>
                                    <span class='gray--text font-title'> <i>Apellido *</i></span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model=email
                                :rules=mailRules
                                label="Email *"
                                outlined
                                dense
                                rounded
                            >
                                <template v-slot:label>
                                    <span class='gray--text font-title'> <i>Email *</i></span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model=phone
                                :rules=ruleRequire
                                outlined
                                dense
                                rounded
                                type="number"
                            >
                                <template v-slot:label>
                                <span class='gray--text font-title'> <i>Teléfono *</i></span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model=address
                                :rules=ruleRequire
                                outlined
                                rounded
                                dense
                            >
                                <template v-slot:label>
                                <span class='gray--text font-title'> <i>Dirección *</i></span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col 
                            cols="12" 
                            sm="6"        
                        >
                            <v-text-field
                                v-model=country
                                :rules=ruleRequire
                                outlined
                                rounded
                                dense
                            >
                                <template v-slot:label>
                                <span class='gray--text font-title'> <i>País *</i></span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col 
                            cols="12" 
                            sm="6" 
                        >
                            <v-text-field
                                v-model=city
                                outlined
                                dense
                                rounded
                                
                            >
                                <template v-slot:label>
                                <span class='gray--text font-title'><i>Ciudad</i></span>
                                </template>
                            </v-text-field>
                        </v-col>  
                        <v-col cols="12">
                            <v-text-field
                                v-model=place
                                outlined
                                dense
                                rounded
                            >
                                <template v-slot:label>
                                <span class='gray--text font-title'><i>Puesto requerido</i></span>
                                </template>
                            </v-text-field>
                        </v-col>    
                        <v-col cols="12">
                            <v-textarea 
                                outlined
                                v-model=message
                            >
                                <template v-slot:label>
                                <span class='gray--text font-title'><i>¿Por qué le gustría trabajar con nosotros?</i></span>
                                </template>
                            </v-textarea>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model=inputFile
                                @change="setFile($event)"
                                :rules=ruleRequire
                                small-chips
                                label="Adjunte su hoja de vida. (Archivos permitidos .pdf .doc .docx .odt)"
                                class='font-title'
                                accept=".doc,.docx,.pdf,.odt"
                            ></v-file-input>
                        </v-col>                         
                    </v-row>
                    <v-col class="text-center">
                        <v-btn 
                            rounded 
                            class='blue  white--text px-8 font-title'
                            @click="sendFormWorkWhitUs"
                        >
                            <b><i>Enviar</i></b>
                        </v-btn>
                    </v-col>
                </v-form>
            </div>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                :absolute=true
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <FooterComponent />
    </div>
</template>

<script>
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import CardServiciosComponent from '../partials/CardServiciosComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import {mapState,mapMutations} from 'vuex'
import Vue from 'vue'
import axios from 'axios'

export default {
    name:'WorkWhitUsComponent',
    data:()=>({
        ruleRequire: [v => !!v || "El campo es obligatorio"],
        mailRules:[
            v => !!v || 'Debe escribir un correo electrónico',
            v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Debe escribir un correo válido'
        ],
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Trabaja con nostros',url:'/trabaja-con-nosotros'}
        ],
        files:[],
        inputFile:null,
        firstName:null,
        lastName:null,
        email:null,
        phone:null,
        address:null,
        country:null,
        city:null,
        place:null,
        message:null,
        overlay:false
    }),
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        CardServiciosComponent,
        MenuMovilComponent  
    },
    computed:{
        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },
        ...mapState(['scrollTop','sweealertForms','url','token'])
    },
    methods:{


        ...mapMutations(['setUrl']),
        
        setFile(files){
            console.log(files)
            this.files= files
        },
        
        sendFormWorkWhitUs(){

            if(!this.$refs.form_quote.validate())
                return false

            this.setUrl('cotizacion-web/1')
            this.overlay=true
            let formData= new FormData()
            formData.append('firstName',this.firstName)
            formData.append('lastName',this.lastName)
            formData.append('email',this.email)
            formData.append('phone',this.phone)
            formData.append('address',this.address)
            formData.append('country',this.country)
            formData.append('city',this.city)
            formData.append('place',this.place)
            formData.append('reason','trabaja con nosotros')
            formData.append('message',this.message)
            formData.append('file',this.files)
            axios.patch(
                this.url,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': 'Bearer '+ this.token
                    }
                }
            ).then(res =>{
                console.log("hola")
                console.log(res)
                Vue.swal({
                    title: res.data.detail,
                    ...this.sweealertForms
                });
                this.firstName=null
                this.lastName=null
                this.email=null
                this.phone=null
                this.address=null
                this.country=null
                this.city=null
                this.place=null
                this.reason=null
                this.message=null
                this.inputFile=null
                this.files=[]

			}).catch(()=>{

            }).then(()=>{
                this.overlay=false
            })

        }

    }
    
}
</script>

<style scope>
    form fieldset {
        border:2px solid #50c995!important
    }
    .v-application .text-sm-h4, .v-application .text-h5{
        font-family: Asap!important
    }
</style>